export const headerSection = {
	fontWeight: '600',
	fontSize: '14px',
	fontFamily: 'Poppins',
};
export const headerStyling = {
	display: 'flex',
	gap: '0.75rem',
	alignItems: 'center',
	minHeight: '44px',
	padding: '0 16px',
	backgroundColor: '#0f4594',
	color: 'white',
	borderRadius: '8px 8px 0 0',
};
export const textStyling = {
	// fontSize: '20px',
	color: '#B8B1B1',
	textAlign: 'center',
};
export const borderColor = {
	width: '100%',
};
export const titleWithTextfield = {
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
};
export const csvStyle = {
	width: '40.77px',
	height: '37.86px',
	cursor: 'pointer',
};
export const pdfStyle = {
	width: '32.3px',
	height: '37.68px',
	cursor: 'pointer',
};
export const grid_Button_Style = {
	display: 'flex',
	justifyContent: 'flex-start',
	gap: '1.5rem',
	alignItems: 'end',
};
export const grid_Icon_Style = {
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'end',
};
export const button_Styles1 = {
	padding: '0.5rem 1.5rem',
	backgroundColor: '#FD7702',
	textTransform: 'capitalize',
	letterSpacing: '0.1rem',
};

export const button_Styles2 = {
	padding: '0.5rem 1.5rem',
	backgroundColor: '#ED2828',
	textTransform: 'capitalize',
	letterSpacing: '0.1rem',
};

export const buttonStyles = {
	display: 'flex',
	justifyContent: 'center',
	gap: '1rem',
	marginLeft: '2rem',
};
export const icon_Grid_Style = {
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'end',
};
export const filterSectionStyle = {
	height: 'auto',
	minHeight: 'unset',
	display: 'block',
	padding: '16px',
	backgroundColor: '#f7f9fd',
};
export const bookIconStyle = {
	position: 'relative',
	justifyContent: 'center',
	display: 'flex',
	top: '-30px',
};
export const bookIconPaperStyle = {
	width: '66px',
	height: '62px',
	borderRadius: '8px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: '#00C7F7',
	cursor: 'pointer',
};
export const paperStyle = {
	padding: '0.5rem',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	cursor: 'pointer',
};
export const titleStyle = {
	color: '#BC1111',
	fontWeight: 'bold',
	padding: '1rem',
	fontSize: '20px',
	marginBottom: '1rem',
};

export const reportPagePaperSx = {
	margin: '1rem',
	borderRadius: '8px',
	border: '1px solid #dbe6f5',
	boxShadow: 'none',
	overflow: 'hidden',
};

export const reportHeaderSx = {
	display: 'flex',
	alignItems: 'center',
	gap: 1,
	minHeight: 44,
	px: 2,
	backgroundColor: '#0f4594',
	color: '#fff',
};

export const reportBackIconSx = {
	width: 22,
	height: 22,
	p: '2px',
	fontSize: '18px',
	color: '#172d58',
	backgroundColor: '#fff',
	borderRadius: '50%',
	cursor: 'pointer',
	'&:hover': {
		backgroundColor: '#eef5ff',
		color: '#0f4594',
	},
};

export const reportTitleSx = {
	fontFamily: 'Poppins',
	fontSize: '14px',
	fontWeight: 600,
	color: '#fff',
};

export const reportFilterPanelSx = {
	m: 2,
	p: 2,
	background: '#fff',
	border: '1px solid #e5edf8',
	borderRadius: '8px',
};

export const reportFilterLabelSx = {
	mb: 0.5,
	fontFamily: 'Poppins',
	fontSize: '12px',
	fontWeight: 600,
	color: '#172d58',
};

export const reportFilterFieldSx = {
	width: '100%',
	'& .MuiInputBase-root': {
		height: 40,
		borderRadius: '6px',
		backgroundColor: '#fff',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#122b55',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: '#d6e2f2',
	},
	'& .MuiOutlinedInput-notchedOutline legend': {
		display: 'none',
	},
	'& .MuiInputLabel-root': {
		display: 'none',
	},
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#b9cbe3',
	},
	'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#2E68BA',
		borderWidth: '1px',
	},
	'& .MuiInputBase-input': {
		padding: '9px 12px',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#122b55',
		boxSizing: 'border-box',
	},
	'& .MuiSelect-select': {
		display: 'flex',
		alignItems: 'center',
	},
};

export const reportMenuProps = {
	PaperProps: {
		sx: {
			maxHeight: 280,
			borderRadius: '8px',
			boxShadow: '0 8px 24px rgba(16, 24, 40, 0.14)',
			'& .MuiMenuItem-root': {
				minHeight: 34,
				py: 0.75,
				fontFamily: 'Poppins',
				fontSize: '13px',
				color: '#122b55',
			},
		},
	},
};

export const reportActionButtonSx = {
	height: 40,
	minWidth: 92,
	borderRadius: '6px',
	px: 2,
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 600,
	textTransform: 'none',
	boxShadow: 'none',
};

export const reportResetButtonSx = {
	...reportActionButtonSx,
	color: '#fff',
	backgroundColor: '#ed2f3b',
	'&:hover': {
		backgroundColor: '#d82431',
		boxShadow: '0 4px 10px rgba(237, 47, 59, 0.2)',
	},
};

export const reportExcelButtonSx = {
	...reportActionButtonSx,
	color: '#16804a',
	borderColor: '#52b47d',
	backgroundColor: '#fff',
	'&:hover': {
		borderColor: '#16804a',
		backgroundColor: '#f0fbf5',
		boxShadow: 'none',
	},
};

export const reportPdfButtonSx = {
	...reportActionButtonSx,
	color: '#ed2f3b',
	borderColor: '#f07b84',
	backgroundColor: '#fff',
	'&:hover': {
		borderColor: '#ed2f3b',
		backgroundColor: '#fff5f6',
		boxShadow: 'none',
	},
};

export const reportEmptyStateSx = {
	minHeight: { xl: 360, lg: 330, md: 280, sm: 220, xs: 180 },
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	textAlign: 'center',
	color: '#6d7890',
};
